const removeItems = () => {
    $('.header__tools__menu .dropdown').each( function() {
        const dropdown = $(this).find('.dropdown-menu');
        $('.header__tools__dropdown').prepend(dropdown);
    });
    addIcons();
}

const addIcons = () => {
    $('.header__tools__dropdown .nav-link ').each( function() {
        const currentContent = $(this).html();
        const newContent = '<i class="icon icon-right"></i> ' + currentContent;
        $(this).html(newContent);
    });
}

const openMenu = el => {
    $('.header__tools__overlay').fadeToggle();
    $('.header__tools__dropdown .dropdown-menu').slideToggle();
    el.toggleClass('active');
}

$(document).ready( function() {
    removeItems();
});

$(document).on('click', '.header__tools__menu .dropdown-menu-toggler', function() {
    openMenu($(this));
})
